import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import type { NavSecondaryItem } from '../index';
import { MessagePreview } from './MessagePreview';
import { useUserStore } from '@/stores/userStore';
import { cn } from "@/lib/utils"

interface NavSecondaryProps {
  items: NavSecondaryItem[];
  className?: string;
}

const PERMISSION_MAP: Record<string, string> = {
  message: 'business:message_center:menu',
};

export function NavSecondary({ items, className }: NavSecondaryProps) {
  const { userInfo } = useUserStore();
  const permissions = userInfo?.permissionCodes || [];

  const filteredItems = items.filter((item) => {
    const permCode = PERMISSION_MAP[item.meta];
    return !permCode || permissions.includes(permCode);
  });
  if (filteredItems.length === 0) return null;

  return (
    <SidebarGroup className={cn('pb-1.5 px-6.5', className)}>
      <SidebarGroupContent>
        <SidebarMenu>
          {filteredItems.map((item) => (
            <SidebarMenuItem key={item.title}>
              {item.meta === 'message' ? (
                <MessagePreview>
                  <SidebarMenuButton asChild size="sm" className="text-sidebar-foreground h-10 rounded-lg">
                    <div className='flex  group-data-[collapsible=compact]:items-center group-data-[collapsible=compact]:justify-center'>
                      <item.icon className="h-3.5 w-3.5" />
                      <span className="text-sm font-medium group-data-[collapsible=compact]:hidden">{item.title}</span>
                    </div>
                  </SidebarMenuButton>
                </MessagePreview>
              ) : (
                <SidebarMenuButton asChild size="sm" className="text-sidebar-foreground h-10 rounded-lg">
                  <a href={item.url}>
                    <item.icon className="h-3.5 w-3.5" />
                    <span className="text-sm font-medium">{item.title}</span>
                  </a>
                </SidebarMenuButton>
              )}
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
